// Frontend Permission System
export const PERMISSIONS = {
  // User Management
  USER_CREATE: 'user.create',
  USER_READ: 'user.read',
  USER_UPDATE: 'user.update',
  USER_DELETE: 'user.delete',
  
  // Patient Management
  PATIENT_CREATE: 'patient.create',
  PATIENT_READ: 'patient.read',
  PATIENT_UPDATE: 'patient.update',
  PATIENT_DELETE: 'patient.delete',
  
  // Caregiver Management
  CAREGIVER_CREATE: 'caregiver.create',
  CAREGIVER_READ: 'caregiver.read',
  CAREGIVER_UPDATE: 'caregiver.update',
  CAREGIVER_DELETE: 'caregiver.delete',
  CAREGIVER_ASSIGN: 'caregiver.assign',
  
  // Care Plans
  CAREPLAN_CREATE: 'careplan.create',
  CAREPLAN_READ: 'careplan.read',
  CAREPLAN_UPDATE: 'careplan.update',
  CAREPLAN_DELETE: 'careplan.delete',
  
  // Billing
  BILLING_READ: 'BILLING_VIEW',
  BILLING_MANAGE: 'BILLING_MANAGE',
  
  // Audit & Compliance
  AUDIT_READ: 'audit.read',
  COMPLIANCE_READ: 'compliance.read',
  COMPLIANCE_MANAGE: 'compliance.manage'
};

export const ROLE_PERMISSIONS = {
  AGENCY_ADMIN: [
    // Full access to everything
    PERMISSIONS.USER_CREATE,
    PERMISSIONS.USER_READ,
    PERMISSIONS.USER_UPDATE,
    PERMISSIONS.USER_DELETE,
    PERMISSIONS.PATIENT_CREATE,
    PERMISSIONS.PATIENT_READ,
    PERMISSIONS.PATIENT_UPDATE,
    PERMISSIONS.PATIENT_DELETE,
    PERMISSIONS.CAREGIVER_CREATE,
    PERMISSIONS.CAREGIVER_READ,
    PERMISSIONS.CAREGIVER_UPDATE,
    PERMISSIONS.CAREGIVER_DELETE,
    PERMISSIONS.CAREGIVER_ASSIGN,
    PERMISSIONS.CAREPLAN_CREATE,
    PERMISSIONS.CAREPLAN_READ,
    PERMISSIONS.CAREPLAN_UPDATE,
    PERMISSIONS.CAREPLAN_DELETE,
    PERMISSIONS.BILLING_READ,
    PERMISSIONS.BILLING_MANAGE,
    PERMISSIONS.AUDIT_READ,
    PERMISSIONS.COMPLIANCE_READ,
    PERMISSIONS.COMPLIANCE_MANAGE
  ],
  
  // Support legacy role names
  'Agency Admin': [
    PERMISSIONS.USER_CREATE,
    PERMISSIONS.USER_READ,
    PERMISSIONS.USER_UPDATE,
    PERMISSIONS.USER_DELETE,
    PERMISSIONS.PATIENT_CREATE,
    PERMISSIONS.PATIENT_READ,
    PERMISSIONS.PATIENT_UPDATE,
    PERMISSIONS.PATIENT_DELETE,
    PERMISSIONS.CAREGIVER_CREATE,
    PERMISSIONS.CAREGIVER_READ,
    PERMISSIONS.CAREGIVER_UPDATE,
    PERMISSIONS.CAREGIVER_DELETE,
    PERMISSIONS.CAREGIVER_ASSIGN,
    PERMISSIONS.CAREPLAN_CREATE,
    PERMISSIONS.CAREPLAN_READ,
    PERMISSIONS.CAREPLAN_UPDATE,
    PERMISSIONS.CAREPLAN_DELETE,
    PERMISSIONS.BILLING_READ,
    PERMISSIONS.BILLING_MANAGE,
    PERMISSIONS.AUDIT_READ,
    PERMISSIONS.COMPLIANCE_READ,
    PERMISSIONS.COMPLIANCE_MANAGE
  ],
  
  CARE_MANAGER: [
    // Limited access - no user management, no billing management, no delete operations
    PERMISSIONS.PATIENT_READ,
    PERMISSIONS.PATIENT_UPDATE,
    PERMISSIONS.CAREGIVER_READ,
    PERMISSIONS.CAREGIVER_ASSIGN,
    PERMISSIONS.CAREPLAN_CREATE,
    PERMISSIONS.CAREPLAN_READ,
    PERMISSIONS.CAREPLAN_UPDATE,
    PERMISSIONS.BILLING_READ  // Can view billing but not manage
  ],
  
  // Support legacy role names
  'Care Manager': [
    PERMISSIONS.PATIENT_READ,
    PERMISSIONS.PATIENT_UPDATE,
    PERMISSIONS.CAREGIVER_READ,
    PERMISSIONS.CAREGIVER_ASSIGN,
    PERMISSIONS.CAREPLAN_CREATE,
    PERMISSIONS.CAREPLAN_READ,
    PERMISSIONS.CAREPLAN_UPDATE,
    PERMISSIONS.BILLING_READ
  ]
};

export const hasPermission = (userRole, permission) => {
  const rolePermissions = ROLE_PERMISSIONS[userRole] || [];
  const result = rolePermissions.includes(permission);
  console.log(`hasPermission check: role=${userRole}, permission=${permission}, result=${result}`);
  return result;
};

export const hasAnyPermission = (userRole, permissions) => {
  return permissions.some(permission => hasPermission(userRole, permission));
};

export const canAccessRoute = (userRole, routePermissions) => {
  if (!routePermissions || routePermissions.length === 0) return true;
  return hasAnyPermission(userRole, routePermissions);
};